import {
  SET_ADMIN_AUDIT_SEARCH_CAPTAIN_VALUE,
  SET_ADMIN_AUDIT_SEARCH_CAPTAINS,
  SET_ADMIN_AUDIT_CAPTAIN_HEADER, 
  SET_ADMIN_AUDIT_CAPTAIN_DETAILS
} from './constants';

export const initialState = { 
    searchCaptainAuditValue: '',
    headerCaptain:{
      captainId: null,
      captainName: '',
      startDate: '',
      endDate: '',
      timeZone: '',
      contactName: '',
      registrationCloseDate: ''
    },

    auditDetails: null,
    searchCaptains: null,
    searchExceededResultLimit: false
};

const reducer = (state = initialState, {type, payload}) => {
  switch (type) {
    case SET_ADMIN_AUDIT_SEARCH_CAPTAIN_VALUE:
      return {
        ...state,
        searchCaptainAuditValue: payload
      }; 
 
    case SET_ADMIN_AUDIT_SEARCH_CAPTAINS:
      return {
        ...state,
        searchCaptains: payload.list,
        searchExceededResultLimit: payload.exceededSearchLimit
      }; 

    case SET_ADMIN_AUDIT_CAPTAIN_HEADER:{
      let captain = initialState.headerCaptain;

      if (payload && payload.captain){
        captain = payload.captain;
      }

      return {
        ...state,
        headerCaptain: captain 
      }; 
    }

    case SET_ADMIN_AUDIT_CAPTAIN_DETAILS:{
      let auditDetails = initialState.auditDetails;

      if (payload && payload.list){
        auditDetails = payload.list;
      }

      return {
        ...state,
        auditDetails: auditDetails 
      }; 
    }
      
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/features/admin/audit/captainAudit/reducer.js